type AuthCodes = {
	readonly DESK_INDEX: string;
	readonly DESK_QUOTE: string;
	readonly DESK_QUERY_POLICY: string;
	readonly DESK_QUERY_QUOTE: string;
	readonly DESK_QUERY_ENDO: string;
	readonly DESK_ENDO: string;
	readonly DESK_CLAIM: string;
	readonly DESK_CLAIM_SERVICE: string;
	readonly DESK_MODIFY_ACCOUNT: string;
	readonly DESK_MODIFY_PWD: string;
	readonly DESK_EXIT: string;

};
// 权限代码
export default {
	DESK_INDEX: 'desk-index',
	DESK_QUOTE: 'desk-quote',
	DESK_QUERY_POLICY: 'desk-query-policy',
	DESK_QUERY_QUOTE: 'desk-query-quote',
	DESK_QUERY_ENDO: 'desk-query-endo',

	DESK_ENDO: 'desk-endo',
	DESK_CLAIM: 'desk-claim',
	DESK_CLAIM_SERVICE: 'desk-claim-service',
	DESK_MODIFY_ACCOUNT: 'desk-modify-account',
	DESK_MODIFY_PWD: 'desk-modify-pwd',
	DESK_EXIT: 'desk-exit'

} as AuthCodes;
